export default "<figure id=\"timeline\"></figure>\n";